import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=4c87701e&"
import script from "./Default.vue?vue&type=script&lang=ts&"
export * from "./Default.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c87701e')) {
      api.createRecord('4c87701e', component.options)
    } else {
      api.reload('4c87701e', component.options)
    }
    module.hot.accept("./Default.vue?vue&type=template&id=4c87701e&", function () {
      api.rerender('4c87701e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layouts/Default.vue"
export default component.exports